module.exports = __webpack_public_path__ + "img/headerbild_image_1920x900.bbdef32c.jpg";